export function parseAddressFromGoogle(type, place) {
    var addressObject = {};
    addressObject[type + "AddressLevelNumber"] = '';
    addressObject[type + "AddressLevelType"] = '';
    addressObject[type + "AddressPostcode"] = '';
    addressObject[type + "AddressState"] = '';
    addressObject[type + "AddressStreetName"] = '';
    addressObject[type + "AddressStreetNumber"] = '';
    addressObject[type + "AddressStreetType"] = '';
    addressObject[type + "AddressSuburb"] = '';
    addressObject[type + "AddressUnitType"] = '';
    addressObject[type + "AddressUnitNumber"] = '';
    var unitNumber = parseComponent(place.address_components, 'subpremise');
    if (parseInt(unitNumber, 10)) {
        unitNumber = parseInt(unitNumber, 10);
    }
    if (!parseInt(unitNumber, 10) && unitNumber.indexOf(' ') > -1) {
        var unitParts = unitNumber.split(' ');
        unitParts.forEach(function (unitPart) {
            if (parseInt(unitPart, 10)) {
                addressObject[type + "AddressUnitNumber"] = parseInt(unitPart, 10);
            }
        });
    }
    addressObject[type + "AddressStreetNumber"] = parseComponent(place.address_components, 'street_number');
    addressObject[type + "AddressStreetName"] = parseComponent(place.address_components, 'route')
        .split(' ')
        .slice(0, -1)
        .join(' ');
    addressObject[type + "AddressStreetType"] = parseComponent(place.address_components, 'route')
        .split(' ')
        .pop();
    addressObject[type + "AddressSuburb"] = parseComponent(place.address_components, 'locality');
    addressObject[type + "AddressState"] = parseComponent(place.address_components, 'administrative_area_level_1', 'short_name');
    addressObject[type + "AddressPostcode"] = parseComponent(place.address_components, 'postal_code');
    return addressObject;
}
export function parseComponent(components, componentType, property) {
    if (property === void 0) { property = 'long_name'; }
    if (!components.some(function (_) { return _.types.indexOf(componentType) > -1; })) {
        return '';
    }
    return components.filter(function (_) { return _.types.indexOf(componentType) > -1; })[0][property];
}
//# sourceMappingURL=parseAddress.js.map